module.exports = __webpack_public_path__ + "static/img/NATHAN-PHILACTIDES.0a9f7a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NATHAN-PHILACTIDES.jpg
// module id = KAXj
// module chunks = 0